function checkPhone(phone) {
    return new Promise((resolve, reject) => {
        let token = $('meta[name="csrf-token"]').attr('content');
        $.ajax({
            url: global_routes.check_phone,
            type: 'POST',
            headers: {'X-CSRF-TOKEN': token},
            data: {
                "_token": token,
                "phone": phone
            },
            success: function (response) {
                if (response.status === "success") {
                    resolve(response.valid); // Résout la promesse avec le résultat de validité
                } else {
                    resolve(false); // Résout la promesse comme non valide si la réponse n'est pas un succès
                }
            },
            error: function () {
                resolve(false); // Résout la promesse comme non valide en cas d'erreur AJAX
            }
        });
    });
}
window.checkPhone = checkPhone;
